var _excluded = ["map", "layer", "onSelect", "onDeselect", "onSelectionChange", "hitTolerance"],
  _excluded2 = ["onSelect", "onDeselect", "onSelectionChange", "hitTolerance"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LayerContext } from '../VectorLayer';
import SelectInteraction from 'ol/interaction/Select';
import { click } from 'ol/events/condition';
function SelectImpl(_ref) {
  var map = _ref.map,
    layer = _ref.layer,
    onSelect = _ref.onSelect,
    onDeselect = _ref.onDeselect,
    onSelectionChange = _ref.onSelectionChange,
    hitTolerance = _ref.hitTolerance,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var callbacks = useRef({});
  useEffect(function () {
    var select = new SelectInteraction(_extends({
      layers: [layer],
      filter: function filter(feature) {
        return feature.get('selectable') !== false;
      },
      condition: click,
      hitTolerance: hitTolerance
    }, props));
    map.addInteraction(select);
    select.on('select', function (e) {
      var _callbacks$current = callbacks.current,
        onSelect = _callbacks$current.onSelect,
        onDeselect = _callbacks$current.onDeselect,
        onSelectionChange = _callbacks$current.onSelectionChange;
      if (e.selected.length !== 0 && onSelect) {
        if (onSelect(e.selected) === false) e.target.getFeatures().clear();
      }
      if (e.deselected.length !== 0 && onDeselect) {
        onDeselect(e.deselected);
      }
      if (onSelectionChange) {
        onSelectionChange(select.getFeatures().getArray());
      }
    });
    return function () {
      map.removeInteraction(select);
    };
  }, [map, layer]);
  useEffect(function () {
    callbacks.current = {
      onSelect: onSelect,
      onDeselect: onDeselect,
      onSelectionChange: onSelectionChange
    };
  }, [onSelect, onDeselect, onSelectionChange]);
  return /*#__PURE__*/React.createElement("span", null);
}

/**
 * Allows overriding default select behaviour on a vector layer.
 *
 * Passed as a child of VectorLayer (or a source rendering a VectorLayer).
 *
 * Additional properties are passed on to ol/interaction/Select.
 */
function Select(_ref2) {
  var onSelect = _ref2.onSelect,
    onDeselect = _ref2.onDeselect,
    onSelectionChange = _ref2.onSelectionChange,
    hitTolerance = _ref2.hitTolerance,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(LayerContext.Consumer, null, function (value) {
    return /*#__PURE__*/React.createElement(SelectImpl, _extends({
      map: value.map,
      layer: value.layer,
      onSelect: onSelect,
      onDeselect: onDeselect,
      onSelectionChange: onSelectionChange,
      hitTolerance: hitTolerance
    }, props));
  });
}
Select.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Callback function when feature (or cluster) is selected.
   * @param {Array} features The features (or clusters) selected.
   * @returns {bool} Return false to cancel selection (i.e. custom selection handling or when just using this as a click handler).
   */
  onSelect: PropTypes.func,
  /**
   * Callback function when feature (or cluster) is deselected.
   * @param {Array} features The features (or clusters) deselected.
   */
  onDeselect: PropTypes.func,
  /**
   * Callback function when feature collection changes.
   * @param {Array} features All features (or clusters) currently selected.
   */
  onSelectionChange: PropTypes.func,
  /**
   * Hit tolerance.
   */
  hitTolerance: PropTypes.number
} : {};
export default Select;